// Tiempo en lenguaje natural (es-MX). Siempre se acompaña de la fecha
// exacta (en el tooltip del componente TiempoRelativo), nunca la reemplaza.
const FMT = new Intl.DateTimeFormat('es-MX', { dateStyle: 'medium', timeStyle: 'short' });
const RTF = new Intl.RelativeTimeFormat('es', { numeric: 'auto' });

const UNIDADES = [
  ['year', 31536000],
  ['month', 2592000],
  ['day', 86400],
  ['hour', 3600],
  ['minute', 60],
];

export function fechaExacta(valor) {
  if (!valor) return '';
  const d = new Date(valor);
  return Number.isNaN(d.getTime()) ? '' : FMT.format(d);
}

// "hace 3 minutos", "en 44 días", "ayer"…
export function relativo(valor) {
  if (!valor) return '';
  const d = new Date(valor);
  if (Number.isNaN(d.getTime())) return '';
  const seg = Math.round((d.getTime() - Date.now()) / 1000);
  if (Math.abs(seg) < 45) return 'hace un momento';
  for (const [unidad, s] of UNIDADES) {
    if (Math.abs(seg) >= s) return RTF.format(Math.round(seg / s), unidad);
  }
  return 'hace un momento';
}
